import React, {Component} from 'react'

export default class InvoiceItemRow extends Component {

    constructor(props) {
        super(props)
        this.state = {
            item: props.item,
            book_keeping_number: props.item.book_keeping_number,
            certification_nb: props.certification_nb,
            is_buyer: props.item.book_keeping_number.substr(0, 1) !== '4',
        }
    }

    render() {

        let sumCurrencyStyle = {};
        let sumStyle = {};
        let certificationNumberStyle = {};


        let isBuyer = this.state.book_keeping_number.substr(0, 1) !== '4';
        let sign = (isBuyer ? 1 : -1);
        let itemSum = (this.props.company.accountant_program_id === 1 && this.state.item.origin_currency !== 'HUF' ? this.state.item.origin_sum : this.state.item.sum) * sign;

        if (!this.state.selected && this.props.selectedInvoiceItemsSum + itemSum === this.props.selectedBankItemsSum) {
            sumStyle = {
                textDecoration: "underline",
                fontWeight: "bold"
            };
        }

        for (var index = 0; index < this.props.selectedBankItems.length; index++) {
            if (this.props.selectedBankItems[index].announcement.toLowerCase().indexOf(this.state.certification_nb.toLowerCase()) !== -1) {
                certificationNumberStyle = {
                    textDecoration: "underline",
                    fontWeight: "bold"
                };
                break;
            }
        }

        let currencyPrice = this.state.item.origin_currency !== 'HUF'
            ? (new Intl.NumberFormat('hu-HU', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.state.item.origin_sum)) + ' ' + this.state.item.origin_currency
            : null;

        return (
            <tr
                key={this.state.item.id}
                className={(this.props.separator ? 'border-top-10' : '') + ' ' + (this.state.item.selected ? 'table-success' : '') + ' cursor-pointer'}
                onClick={() => this.props.toggleItemRow(this.state.item, 'assignments')}
            >
                <td style={{color: this.state.is_buyer ? 'green' : 'red'}}>{this.state.book_keeping_number} {this.state.is_buyer ? 'Vevő' : 'Szállító'}</td>
                <td>{this.state.item.day}</td>
                <td className={this.props.show_currency ? '' : 'd-none'} style={sumCurrencyStyle}>{currencyPrice}</td>
                <td style={sumStyle}>{new Intl.NumberFormat('hu-HU', {minimumFractionDigits: 2, maximumFractionDigits: 2}).format(this.state.item.sum)} {this.state.item.currency}</td>
                <td style={certificationNumberStyle}>{this.state.certification_nb}</td>
                <td className={this.props.show_announcement ? '' : 'd-none'}>{this.state.item.announcement}</td>
            </tr>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/bank/steps/pairing/InvoiceItemRow.js